import React from 'react';

import { EntityLayout } from '@backstage/plugin-catalog';

import { AIToolsOverviewContent } from '../Content/AIToolsOverviewContent';

export const AIToolsEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <AIToolsOverviewContent />
    </EntityLayout.Route>
  </EntityLayout>
);
